import { Box, Typography } from '@mui/material';
import MemoryIcon from '@mui/icons-material/Memory';
import { router } from './router';

export const Branding = () => {
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      onClick={() => router.navigate('/')}
    >
      <MemoryIcon
        sx={{ display: { xs: 'none', md: 'flex' }, mr: 1, fontSize: 28 }}
      />
      <Typography
        component="div"
        sx={{
          mr: 2,
          display: { xs: 'none', md: 'flex' },
          fontSize: 17,
          fontWeight: 700,
          letterSpacing: '0.08em',
          color: 'inherit',
          textDecoration: 'none',
          lineHeight: 1
        }}
      >
        Algo Trader
      </Typography>
    </Box>
  );
};
